export const formatNumber = (value: number | null | undefined, unit: string): string => {
  if (!value) return `0 ${unit}`
  const num = Number(value)
  return num % 1 === 0
    ? `${num.toLocaleString('ru-RU', { maximumFractionDigits: 0 })} ${unit}`
    : `${num.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${unit}`
}